import styled from 'styled-components';
import { Button } from '@mui/material';

export const Container = styled.div``;

export const ButtonTrigger = styled(Button)`
  &&& {
    background: none;
    border: none;
    min-width: fit-content;
  }
`;

export const DropdownArea = styled.div`
  border: 1px solid;
  padding: 1rem;
  background-color: #ffff;
`;

